import React, { useEffect, useState, useContext } from 'react';
// import { Nav, NavItem, NavLink, UncontrolledTooltip } from 'reactstrap';
import { Nav } from 'reactstrap';
import ProfileDropdown from './ProfileDropdown';
import NotificationDropdown from './NotificationDropdown';
import { toast } from 'react-toastify';
import getFirebase from '../../services/firebase';
import { getAdminToken } from '../../services/authService';
import { levelFormatter, renewalStatusFormatter } from '../../utils/tableFormatters';
import { APPLICATION_STATUS } from 'Types/constants';
import Logo from './Logo';
import AppContext from '../../context/Context';
import classNames from 'classnames';
import { navbarBreakPoint } from '../../config';
import { RENEWAL_STATUS } from 'Types/constants';
import { getMemberRenwalStatus } from 'services/memberService';

const firebase = getFirebase();
const db = getFirebase().firestore();

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
};

const TopNavRightSideNavItem = () => {
  const {
    showBurgerMenu,
    setShowBurgerMenu,
    isTopNav,
    isVertical,
    isCombo,
    navbarCollapsed,
    setNavbarCollapsed
  } = useContext(AppContext);

  const handleBurgerMenu = () => {
    isTopNav && !isCombo && setNavbarCollapsed(!navbarCollapsed);
    (isCombo || isVertical) && setShowBurgerMenu(!showBurgerMenu);
  };

  const [loading, setLoading] = useState(true);
  const [uid, setUid] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);
  // const [isAdmin, setIsAdmin] = useState(false);
  const [name, setName] = useState('');
  const [userPhoto, setUserPhoto] = useState('');
  const [level, setLevel] = useState(APPLICATION_STATUS.INCOMPLETE_MEMBER);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [renewalStatus, setRenewalStatus] = useState(RENEWAL_STATUS.NOT_STARTED);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const GetToken = async () => {
      const token = await getAdminToken();
    };

    GetToken();
  }, []);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(async user => {
      if (user && user.uid) {
        setUid(user.uid);

        db.collection('authority')
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              setLevel(doc.data().level);

              if (doc.data().name) {
                setName(`${doc.data().name ?? ''} ${doc.data().surname ?? ''}`);
              }
            }
          })
          .catch(error => {
            console.error('Error getting document:', error);
            toast.error('An error occured!', {
              autoClose: 100
            });
          });

        db.collection('members')
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              const pd = doc.data().PersonalDetails;
              if (pd && pd.photo) setUserPhoto(pd.photo);
            }
          })
          .catch(error => {
            console.error("Error retrieving member's details:", { error, user });
          });

        setLoggedIn(true);

        const renewalStatus = await getMemberRenwalStatus(user.uid);
        console.log('Fetched renewal status:', renewalStatus, user.uid);
        setRenewalStatus(renewalStatus);
        setLoading(false);
      } else {
        setLoggedIn(false);
        setLoading(false);
      }
    });

    // Cleanup function to unsubscribe when component unmounts
    return () => unsubscribe();
  }, []);

  return (
    <Nav navbar className="navbar-nav-icons flex-row align-items-center w-100">
      <div className="d-flex align-items-center mr-auto">
        <button
          className={classNames(
            'navbar-toggler-humburger-icon btn btn-link d-flex flex-center mr-2 toggle-icon-wrapper',
            {
              'd-lg-none': isTopNav && !isCombo,
              [`d-${navbarBreakPoint}-none`]: isVertical || isCombo
            }
          )}
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>

        <Logo at="navbar-top" />
      </div>

      {/* User info and actions - render when ready */}
      {!loading && name && (
        <>
          {windowDimensions.width > 430 && (
            <li className="nav-item d-none d-lg-block text-right mr-2">
              <div className="d-flex flex-column align-items-end">
                <span className="font-weight-bold" style={{ fontSize: '1.05rem', lineHeight: 1.1 }}>
                  {name}
                </span>
                <div className="d-flex flex-row align-items-center mt-1" style={{ gap: '0.25rem' }}>
                  <span>{levelFormatter(level)}</span>
                  {level != 'ADMIN' && renewalStatus !== RENEWAL_STATUS.NOT_STARTED && (
                    <span>{renewalStatusFormatter(renewalStatus)}</span>
                  )}
                </div>
              </div>
            </li>
          )}

          <NotificationDropdown />
          <ProfileDropdown uid={uid} level={level} loggedIn={loggedIn} name={name} userPhoto={userPhoto} />
        </>
      )}
    </Nav>
  );
};

export default TopNavRightSideNavItem;
